import React from "react";
import { GetProductionAtomData, SetProductionAtomData } from "../../store/productionAtom";
import { formatCustomDate } from "../../helpers/formatCustomDate";

const ProductionScrollBar = ({ onSelect }) => {
        const getProductionAtomData = GetProductionAtomData();




  return (
    <div className="w-1/5 bg-gray-50 border-r overflow-y-auto h-screen">
      <h2 className="text-lg font-semibold p-4 border-b">Finish Items</h2>
      <ul className="divide-y">
        {getProductionAtomData?.production_info.map((product, idx) => (
          <li
            key={idx}
            onClick={() => onSelect(product)}
            className="p-2 hover:bg-gray-100 cursor-pointer"
          >
            <p className="font-medium text-blue-500">{product.Production_Item_Name}</p>
            <p className="text-sm text-gray-600">
              Ref. No: {product.Ref_No} • Qty: {product.Production_Quantity}
            </p>
            <p className="text-xs text-gray-400">{formatCustomDate(product.Production_Date)}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProductionScrollBar;
